var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"cp-tip",class:_vm.show ? 'showtip' : ''},[_c('span',[_vm._v(_vm._s(_vm.tip))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }